import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PhitoNotification } from '../classes/PhitoNotification';
import { PhitoUtils } from '../../../utils/phito-utils';
import { PhitoDateUtils } from '../../../utils/phito-date-utils';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'phito-notification-popup-item',
    templateUrl: './notification-popup-item.component.html',
    styleUrls: ['./notification-popup-item.component.scss'],
    imports: [MatTooltip, MatIconButton, MatIcon],
})
export class NotificationPopupItemComponent implements OnInit {
    @Input('notification') notification: PhitoNotification;
    @Input('popup') popup = true;
    @Output('closed') closed = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}

    closeNotification(msg: any) {
        this.closed.emit();
        console.log('CLOSE NOTIFICATION', msg);
    }

    getAcronym(notification: PhitoNotification) {
        return PhitoUtils.getAcronym(notification.createdBy);
    }

    formatDate(createdAt: Date) {
        return PhitoDateUtils.beautify(createdAt);
    }
}
